module.exports = __webpack_public_path__ + "static/img/1807_phase_function_Paper_Points.0df48a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1807_phase_function_Paper_Points.png
// module id = iME5
// module chunks = 0